import { useState, useEffect } from 'react';
import type { ReactNode } from 'react';
import { BrandThemeContext, type BrandTheme, BRAND_LOGO_SRC } from './use-brand-theme';

function resolveStoredBrand(stored: string | null): BrandTheme {
  // Legacy migration: the orange brand was previously named 'red'.
  const value = stored === 'red' ? 'orange' : stored;
  return value === 'orange' || value === 'blue' ? value : 'blue';
}

export function BrandThemeProvider({ children }: { children: ReactNode }) {
  const [brand, setBrandState] = useState<BrandTheme>(
    () => resolveStoredBrand(localStorage.getItem('compbox-brand-theme'))
  );

  useEffect(() => {
    const root = document.documentElement;
    root.dataset.brand = brand;
    if (brand === 'orange') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    document.querySelector<HTMLLinkElement>('link[rel="icon"]')
      ?.setAttribute('href', BRAND_LOGO_SRC[brand]);
    localStorage.setItem('compbox-brand-theme', brand);
  }, [brand]);

  return (
    <BrandThemeContext.Provider value={{ brand, setBrand: setBrandState }}>
      {children}
    </BrandThemeContext.Provider>
  );
}
